import React, { Fragment, useEffect, useContext, useState } from "react";
import { Link, Redirect } from "react-router-dom";
import { observer, useObserver } from "mobx-react-lite";

/* packages */
import { GlobalContext } from "../../lib-atomic-context";
import {
  ModuleTitle,
  ModuleText,
  ModuleTextSmall,
  ModuleSubTitle,
  ModuleFormWrapper,
  ModuleFormItemWrapper,
  ModuleFormItemShortWrapper,
  ModuleFormItemLongWrapper,
  ModulePaperWrapper,
  ModuleTextProductTotal,
} from "../../lib-atomic-design-section";
import { LocalStorage } from "../../lib-atomic-functions";
/* packages */

const index = (props) => {
  const notesLS = LocalStorage.getLS().notes;
  const { notes } = useContext(GlobalContext);

  let customnotes = "";

  if (notesLS) {
    customnotes = notesLS;
  } else {
    return null;
  }
  // if (notes.state.data) {
  //   customnotes = notes.state.data.ordernotes;
  // } else {
  //   return null;
  // }

  return (
    <ModuleFormItemLongWrapper>
      <ModulePaperWrapper>
        <ModuleFormWrapper>
          <ModuleFormItemLongWrapper>
            <ModuleSubTitle>
              <b>Purchase Order No.</b>
            </ModuleSubTitle>
            <ModuleText>{customnotes}</ModuleText>
          </ModuleFormItemLongWrapper>
        </ModuleFormWrapper>
      </ModulePaperWrapper>
    </ModuleFormItemLongWrapper>
  );
};

export default index;
